import { ConsumerOrders } from "../../containers/Order";

const Orders = () => {
  return (
    <div className="orders-page full-bleed">
      <ConsumerOrders />
    </div>
  );
};

export default Orders;
